// system/infra-params — the install's real bicep suffix + params.
//
// WRITERS: `m8t platform enable-auto-update` (the authoritative write — it has
// every param in hand) and a full converge's re-stamp, which refreshes the
// existing row. `m8t deploy` does NOT write this row.
//
// The updater job READS this row to run an infra converge without guessing the
// suffix (a wrong suffix provisions a duplicate stack) — never reconstruct
// these params from scratch, read the row.
//
// Secret audit: every field below is a non-secret resource ID / ref / suffix
// (ARM resource IDs, an image ref, a tenant/client ID, a project endpoint,
// and the deployment suffix) — the plain Metadata row is fine as-is, no KV
// reference needed. If a FUTURE param ever carries a secret (e.g. a
// connection string), store a KV reference string (e.g. `kv://vault/secret`
// or an `op://...` style pointer) here, NEVER the raw secret value.
export interface InfraParams {
  schemaVersion: 1;
  suffix: string;
  bicep: {
    location: string;
    imageRef: string;
    tenantId: string;
    clientId: string;
    foundryResourceId: string;
    foundryProjectEndpoint: string;
    acrPullIdentityResourceId: string;
    acrResourceId: string;
    foundryTracingMode?: string;
    /** Release-channel URL this install was deployed with. Non-secret (a public
     *  manifest URL). Persisted so a converge re-emits it instead of dropping the
     *  gateway's channel env on the next infra apply. */
    channelUrl?: string;
  };
  updatedAt: string;
}

export const INFRA_PARAMS_PK = "system";
export const INFRA_PARAMS_RK = "infra-params";

export function infraParamsToEntity(p: InfraParams): { partitionKey: string; rowKey: string; value: string } {
  return { partitionKey: INFRA_PARAMS_PK, rowKey: INFRA_PARAMS_RK, value: JSON.stringify(p) };
}

export function entityToInfraParams(e: { value: string }): InfraParams {
  return JSON.parse(e.value) as InfraParams;
}
